module.exports = __webpack_public_path__ + "static/media/booking.de3b1458.svg";